function sortPortals(portals, sortBy) {
  if (!portals) {
    return undefined;
  }
  return portals.sort((a, b) => {
    switch (sortBy) {
      case "lexicographic":
        return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
      case "grade_level":
        {
          // In case a portal does not have any levels associated to them, then
          // display them last.
          const primarySort = (a.levels[0] ?? 9999) - (b.levels[0] ?? 9999);
          if (primarySort !== 0) {
            return primarySort;
          }

          // In case the first level matches, then sort based on the largest level
          // of the portal
          return (a.levels[a.levels.length - 1] ?? 9999) - (b.levels[b.levels.length - 1] ?? 9999);
        }
    }
  });
}

export { sortPortals };
//# sourceMappingURL=util.sort.js.map
